import React from 'react';
import cn from 'classname';

import Form from './form';
import './index.less';

function Row({ row, index, isHiddenCopyCols, ...props  }) {
	return (
		<tr className={cn({ 'modify-background': index % 2, 'table-register-row': true})}>
			{!isHiddenCopyCols && <td>{row.id}</td>}
			<td>
				<span
					onClick={props.toggleChangeDateForm.bind(null, row)}
					className="text-underline"
				>
					{row.day_after_accepted_at}
				</span>
				<Form
					row={row}
					{...props}
				/>
			</td>
			<td>{row.created_at}</td>
			<td>{row.weekly_valid_conversions_count}</td>
			<td>{Number(row.granted_volume || row.planned_volume || 0) * 7}</td>
			{<td>{row.maxDailyLeads}</td>}
			{<td>{row.manager}</td>}
			<td>{row.affiliate}</td>
			{!isHiddenCopyCols && <td>{row.affiliate_id}</td>}
			<td>{row.offer}</td>
			<td>{row.country}</td>
			{
				!isHiddenCopyCols &&
				<td>
					{row.sid ? `${row.sid} ${row.sid_type ? `(${row.sid_type})` : ''} & ` : ''}  {row.campaign_id}
				</td>
			}
			{!isHiddenCopyCols && <td>{Number(row.last_amount) || ''} $</td>}
			<td>{Number(row.payout_decision)} $</td>
			{!isHiddenCopyCols && <td>{row.admin}</td>}
			<td>
				{row.scaling_stopped_at}
			</td>
			<td className="actions">
				<div className="display-flex flex-center">
					{
						props.can('payout_requests_review') &&
						<a className="action_delete margin-0-10" href="#" onClick={props.delete.bind(null, row.id)}/>
					}
					{
						props.can('payout_requests_review') && !row.scaling_stopped_at &&
						<a className="action_stop margin-0-10" href="#" onClick={props.stop.bind(null, row.id)}/>
					}
					{
						props.can('payout_requests_review') && row.scaling_stopped_at &&
						<a className="action_start margin-0-10" href="#" onClick={props.start.bind(null, row.id)}/>
					}
				</div>
			</td>
		</tr>
	);
}

export default Row;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-scaling/row.js